<template>
  <div class="flex flex-col items-center justify-center min-h-screen">
    <div v-if="loading" class="text-lg">Rejecting invitation...</div>
    <div v-else-if="error" class="text-red-500 text-lg">
      <p>Error: {{ error.message }}</p>
    </div>
    <div v-else-if="success" class="text-primary text-lg">
      You have successfully rejected the invitation.
    </div>
    <div v-else>
      <h1 class="text-2xl font-bold mb-4">Reject Invitation</h1>
      <button @click="handleReject" class="bg-red-500 text-white p-2 rounded-md">
        Reject Invitation
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRejectInvitation } from '@/composables/useRejectInvitation';

const route = useRoute();
const token = route.params.token as string;
const success = ref(false);

const { rejectInvitation, loading, error, onDone } = useRejectInvitation();

const handleReject = async() => {
  await rejectInvitation({ token });
};

onDone(() => {
  success.value = true;
});

onMounted(() => {
  // If the user is already logged in, we can directly reject the invitation
  // You might want to add a check for login status here
});
</script>
